export default {
  en: {
    Title: "Activity Based Costing",
    KpiTitle : "KPI",
    Year : "Year",
    Period : "Periods",
    Projects : "Locations",
    SelectPeriod : "Please select a period",
    SelectProject : "Please select a location",
    OPEX : {
      Title : "Cost of production",
      BaseValue : "($)",
      OPEXPerOz : "($ / oz)",
      OPEXPerTonOre : "($ / t Ore)",
      OPEXPerMadv : "($ / madv)",
      OPEXPerMdrl : "($ / mdrl)",
      OPEXPerTDev : "($ / tDev)",
      OPMining : "Open Pit Mining",
      UGMining : "Underground Mining",
      HLProcessing : "Heap Leach Processing",
      MillProcessing : "Mill Processing",
      UGDevelopmentOre : "Ore UG Development Tons"
    },
    OreTons : {
      Title : "Ore Tonnes"
    },
    CAPEX : {
      Title : "CAPEX"
    },
    GoldProduction : {
      Title : "Gold Production"
    },
    Development : {
      Title : "Lateral Development",
      ShortTitle : "Development",
      Drilling : "Development drilling"
    },
    Production : "Production",
    Services : "Services",
    Maintenance : "Maintenance",
    Drilling : "Drilling",
    Blasting : "Blasting",
    Mucking : "Mucking",
    Hauling : "Hauling",
    MeterOfAdvance : "Meter of advance",
    MeterDrilled : "Meter Drilled",
    UGDevelopmentOre : "Lateral Development Tonnes Mucked",
    DirectProductionExpensePerAccount : "Direct Production Expense per account",
    PerformanceFactor1 : "Performance factor 1",
    PerformanceFactor2 : "Performance factor 2",
    PerformanceFactor3 : "Performance factor 3",
    PerformanceFactor4 : "Performance factor 4",
    Workforce : "Workforce",
    Equipment : {
      Title : "Equipment",
      Units : "Equipment Units",
      Performance : "Equipment Performance"
    }
  }
}
